/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {
    useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import addressControl from 'twia-capability-address-component/util/addressControl';
import appConfig from 'app-config';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { TWIAPhoneComponent, TWIAAddressComponent, TWIAEmailComponent } from 'twia-capability-address-component';
import { AddressStandardizationServiceCC } from 'twia-capability-fnol-addressstandardization';
import { Loader, useModal } from '@jutro/components';
import { wizardMessages } from 'tfpa-portals-wizard-components-ui';
import messages from '../../FNOL.messages';
import Address from '../../models/Address';
import Claim from '../../models/Claim';
import Phone from '../../models/Phone';
import metadata from './ContactDetailsPage.metadata.json5';
import styles from './ContactDetailsPage.module.scss';

function FNOLContactDetailsPage(props) {
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { wizardData: claimVM, updateWizardData,steps} = props;
    
    const [availableContacts, setAvailableContacts] = useState([]);
    const newContact = {
        placeholder: true,
    };
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerComponentValidation,
    } = useValidation('FNOLContactDetailsPage');
    const addressModel = !_.isEmpty(_.get(claimVM,'mainContact.value')) ? 
    _.get(claimVM,'mainContact.primaryAddress') : undefined

    const [addressVM, setAddressVM] = useState(addressModel);
    const { showConfirm } = useModal();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const isPerson = _.get(claimVM, 'mainContact.subtype.value') === 'Person';
    const [emailValidationMessages, setEmailValidationMessage] = useState([]);
    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    const country = _.get(claimVM, 'mainContact.primaryAddress.country.value.code');
    const breakpoint = useContext(BreakpointTrackerContext);
    const isEmailrequired = _.get(claimVM, 'mainContact.emailAddress1.aspects.required');
    const isHomePhoneRequired = _.get(claimVM, 'mainContact.homeNumber.aspects.required');
    const isWorkPhoneRequired = _.get(claimVM, 'mainContact.workNumber.aspects.required');
    const isCellPhoneRequired = _.get(claimVM, 'mainContact.cellNumber.aspects.required');
    const relationType = viewModelService.productMetadata.get('cc').types.getTypelist('PersonRelationType');
    const [homePhoneValidationMessage, setHomePhoneValidationMessage] = useState([]);
    const [workPhoneValidationMessage, setWorkPhoneValidationMessage] = useState([]);
    const [cellPhoneValidationMessage, setCellPhoneValidationMessage] = useState([]);
    const isPhoneNumberValid = (phone) => /^[2-9]\(?([0-9]{2})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(phone);
    const [ ccConstants, setCCConstants ] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [isButtonDisabled, updateDisablity] = useState(false);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const authUserData = _.get(useAuthentication(), 'authUserData');
    // const { authHeader, authUserData } = useAuthentication();
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
    const selectedUWCompany = isTFPA ?  'tfpa' : 'twia';    
    const xPortal = 'CC';
    const [ isAddressEdited, setIsAddressEdited ] = useState(false);
    const [loader,setLoader] = useState(false);
    const [contactUpdated, setContactUpdated] = useState(false);
    const { refreshData } = useDataRefresh();

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'FNOLContactDetailsPage');
        }
    }, [isComponentValid, onValidate]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);
    
    const getCCConstants = useCallback(async () => {
        if(authHeader) {
        const constants = await AddressStandardizationServiceCC.getCCPortalConstants(authHeader);

        if (!constants.portalAddressStandardizationEnabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }

        setCCConstants(constants);
        }
    }, [authHeader]);

    useEffect(() => {

        if(!_.isEmpty(_.get(claimVM,'mainContact.value'))){
          const addressNotValidated =  _.get(claimVM.value,'mainContact.primaryAddress.addressVerifyStatusExt') === 'notvalidated';
          const nonUSCheck = _.get(claimVM.value, 'mainContact.primaryAddress.value?.country') !== 'US';

            if(addressNotValidated && !nonUSCheck) {
                setIsAddressEdited(true);
            }

            setAddressVM(_.get(claimVM,'mainContact.primaryAddress'));
        }
       
        getCCConstants();
    }, [getCCConstants]);
    
    const setDisablity = useCallback((value) => {
        if (!isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, 'CC'))
        }
    }, [isStandardizationDisabled, updateDisablity]);

    const updatePolicyAddressVM = useCallback((value) => {
        const addressValue = value?.value || value

        //setAddressVM(addressValue);
        _.set(claimVM, 'mainContact.primaryAddress', addressValue);
        setDisablity(addressValue);

        if(addressValue?.addressVerifyStatusExt === 'validated') {
            _.set(claimVM, 'mainContact.primaryAddress.isValidated_Ext', true);
            setIsAddressEdited(false);
            updateWizardData(claimVM);
            setAddressVM(claimVM.mainContact.primaryAddress);
        } else if(addressValue?.addressVerifyStatusExt === 'overridden') {
            _.set(claimVM, 'mainContact.primaryAddress.isOverridden_Ext', true);
            setIsAddressEdited(false);
            updateWizardData(claimVM);
            setAddressVM(claimVM.mainContact.primaryAddress);
        }

        updateWizardData(claimVM);
    }, [claimVM, updateWizardData, setDisablity]);

    const validateEmail = useCallback(
        (value, path) => {
            _.set(claimVM, path, value);
            setEmailValidationMessage([]);

            if (!value) {
                if (isEmailrequired) {
                    setEmailValidationMessage([messages.required]);
                } else {
                    setEmailValidationMessage([]);
                }
            } else if (!isEmail(value)) {

                setEmailValidationMessage([translator(messages.EmailValidationMessage)])
            }

        },
        [claimVM, translator, isEmailrequired]);

    const getAvailableContacts = useCallback(
        newClaimVM => {
            const contactsData = newClaimVM.value
                .availableContacts()
                .filter(contact => contact.subtype === 'Person');

            const isnewContactAdded = _.some(newClaimVM.value.contacts, contact => contact.tempID !== undefined);

            if (!isnewContactAdded) {
                contactsData.push(newContact);
            }

            const dropDownContacts = contactsData.map(contact => {
                const availableContact = contact.placeholder
                    ? translator(messages.otherPerson)
                    : contact.getDisplayName(translator(messages.newContact));

                return {
                    code: availableContact,
                    name: availableContact,
                };
            });

            return dropDownContacts;
        },
        [newContact, translator]
    );

    const initializeVM = useCallback(() => {
        const claimObj =  new Claim(claimVM.value);
        const submittingClaimVM = viewModelService.create(
            claimObj,
            'cc',
            'edge.capabilities.claim.fnol.dto.FnolDTO',
            {
                SubmittingClaim: true,
            }
        );
        const newClaimVM = viewModelService.clone(submittingClaimVM);

        updateWizardData(newClaimVM);

        return newClaimVM;
    }, [claimVM, updateWizardData, viewModelService]);

    const isContactNumberCheck = useCallback(() => {
        if (
            claimVM?.mainContact?.aspects?.valid &&
            claimVM?.mainContact?.aspects?.subtreeValid
        ) {
            return true;
        }

        return false;
    }, [claimVM]);

    useEffect(
        () => {
            setLoader(true);

            const newClaimVM = initializeVM();

            if (_.isEmpty(newClaimVM.value.mainContact)) {
                newClaimVM.value.mainContact = newClaimVM.value.createContact();
                // newClaimVM.value.mainContact.primaryPhoneType = 'work';
                newClaimVM.value.mainContact.displayName = translator(
                    messages.newContact
                );
                newClaimVM.value.mainContact.primaryAddress = new Address();
            }

            if(newClaimVM.mainContact.primaryAddress.value?.addressVerifyStatusExt === undefined){
                newClaimVM.mainContact.primaryAddress.value.addressVerifyStatusExt = "notvalidated"; // DE17150
            }

            if(newClaimVM.mainContact.primaryAddress.value?.country === 'US') {
                newClaimVM.mainContact.primaryAddress.value.mustStandardize_Ext = true;
            } else {
                newClaimVM.mainContact.primaryAddress.value.mustStandardize_Ext = false;
            }

            setAddressVM(_.get(newClaimVM,'mainContact.primaryAddress'));

            // DE18451/DE18452 - 'New Contact' is defaulted - updating Preferences
            const preferredMethodofCorrExt = _.get(newClaimVM.value, 'mainContact.preferredMethodofCorrExt');
            const preferredMethodofCommExt = _.get(newClaimVM.value, 'mainContact.preferredMethodofCommExt');
            const preferredLanguageExt = _.get(newClaimVM.value, 'mainContact.preferredLanguageExt');
            _.set(newClaimVM.value, 'mainContact.preferredMethodofCorrExt', (preferredMethodofCorrExt || 'email'));
            _.set(newClaimVM.value, 'mainContact.preferredMethodofCommExt', (preferredMethodofCommExt || 'phone'));
            _.set(newClaimVM.value, 'mainContact.preferredLanguageExt', (preferredLanguageExt || 'english'));

            _.set(claimVM,'value',newClaimVM.value)
         
            props.markStepSubmitted(steps[1])
            updateWizardData(claimVM)
            updatePrimaryPhoneFields(claimVM);

            const getContactList = getAvailableContacts(newClaimVM);

            setAvailableContacts(getContactList);
            setLoader(false);
        },
        []
    );

    useEffect(() => {
        registerComponentValidation(isContactNumberCheck);
    }, [isContactNumberCheck, registerComponentValidation]);

    const handleContactChange = useCallback(
        value => {
            if (value === translator(messages.otherPerson)) {
                const areContactsValid = _.every(
                    _.get(claimVM.value, 'contacts'),
                    contact =>
                        contact.displayName !== translator(messages.newContact)
                );

                if (areContactsValid) {
                    claimVM.mainContact.value = claimVM.value.createContact();
                    claimVM.mainContact.displayName.value = translator(
                        messages.newContact
                    );
                    claimVM.mainContact.primaryAddress.value = new Address();
                    claimVM.value.mainContact.value = new Phone();
                    claimVM.value.mainContact.preferredMethodofCommExt = 'phone';
                    claimVM.value.mainContact.preferredMethodofCorrExt = 'email';
                    claimVM.value.mainContact.preferredLanguageExt = 'english';
                    claimVM.value.mainContactTypeExt = null;
                    claimVM.value.mainContact.primaryPhoneType = null;
                    claimVM.mainContact.primaryAddress.value.mustStandardize_Ext = true;

                    if(claimVM.mainContact.primaryAddress.value?.addressVerifyStatusExt === undefined){  //DE17476
                        claimVM.mainContact.primaryAddress.value.addressVerifyStatusExt = "notvalidated";
                        setIsAddressEdited(true);
                    }

                    const getContactList = getAvailableContacts(claimVM);

                    setAvailableContacts(getContactList);
                    updateWizardData(claimVM)
                    refreshData();
                }
            }

            if (value !== translator(messages.otherPerson)) {

                const selectedMainContact = _.find(
                    claimVM.value.contacts,
                    contact => {
                        const contactName = contact.displayName
                            ? contact.displayName
                            : contact.getDisplayName();

                        return contactName === value;
                    }
                );
                
                selectedMainContact.primaryAddress = !_.isEmpty(
                    selectedMainContact.primaryAddress
                )
                    ? selectedMainContact.primaryAddress
                    : new Address();
                selectedMainContact.displayName = !_.isEmpty(
                    selectedMainContact.displayName
                )
                    ? selectedMainContact.displayName
                    : selectedMainContact.getDisplayName();

                selectedMainContact.primaryPhoneType = !_.isEmpty(
                    selectedMainContact.primaryPhoneType
                )
                    ? selectedMainContact.primaryPhoneType
                    : null;

                const selectedContactRole = selectedMainContact.policyRole;

                if (selectedContactRole) {
                    if (selectedContactRole === 'agent') {
                        claimVM.mainContactTypeExt.value = relationType.getCode('agent');
                    }

                    if (selectedContactRole === 'insured') {
                        claimVM.mainContactTypeExt.value = relationType.getCode('self');
                    }
                } else {
                    claimVM.mainContactTypeExt.value = null
                }

                _.set(claimVM, 'mainContact.value', selectedMainContact);

                claimVM.value.contacts.forEach((contact, index) => {  //DE18404
                    if (claimVM.value.contacts[index]?.primaryAddress?.addressVerifyStatusExt === undefined || claimVM.value.contacts[index]?.primaryAddress?.addressVerifyStatusExt === "notvalidated") {
                       // claimVM.value.contacts[index].primaryAddress.addressVerifyStatusExt = "notvalidated";
                        setIsAddressEdited(true);
                    }
                });
                

                if (selectedContactRole !== 'insured' && selectedMainContact?.publicID) {
                    _.set(claimVM.value, 'mainContact.publicID', null);
                    _.set(claimVM.value, 'mainContact.primaryAddress.publicID', null);
                }

                updateWizardData(claimVM);
                setContactUpdated(true);
            }
        },
        [claimVM, getAvailableContacts, translator, updateWizardData, relationType]
    );

    const handleNameChange = useCallback(
        (value, path) => {
            _.set(claimVM, path, value);

            const selectedContactArray = _.filter(
                claimVM.contacts.value,
                contact => {
                    if ('tempID' in contact) {
                        if (
                            contact.tempID === claimVM.mainContact.tempID.value
                        ) {
                            return contact;
                        }
                    }

                    return null;
                }
            );
            let newDisplayName = '';

            if (!_.isEmpty(selectedContactArray)) {
                newDisplayName = selectedContactArray[0].getDisplayName(
                    translator(messages.newContact)
                );
            } else {
                newDisplayName = claimVM.value.mainContact?.getDisplayName(
                    translator(messages.newContact)
                );
            }    
                   
            _.set(claimVM, 'mainContact.displayName.value', newDisplayName);
            updateWizardData(claimVM);
            
            const addNew = getAvailableContacts(claimVM);

            setAvailableContacts(addNew);
        },
        [claimVM, getAvailableContacts, translator, updateWizardData]
    );

    const getRelationShipTypeValues = useCallback(() => {
        const availableRelationshipTypeValues = claimVM?.mainContactTypeExt?.aspects?.availableValues

        if (availableRelationshipTypeValues?.length > 0) {
            const availableInterestType = availableRelationshipTypeValues.map((code) => ({
                    code: code.code,
                    name: code.code === 'self' ? 'Self' : translator({ id: code.name })
                }))

            return availableInterestType
        }
    }, [claimVM, translator]);

    const updateclaimVM = useCallback((accountVM) => {
        _.set(claimVM, 'mainContact.value', accountVM.value)
        updateWizardData(claimVM);
    }, []);

    const updatePrimaryPhoneFields = useCallback(() => {

        const homeCode = _.get(claimVM, 'mainContact.homeNumber.value');
        const workCode = _.get(claimVM, 'mainContact.workNumber.value');
        const cellCode = _.get(claimVM, 'mainContact.cellNumber.value');

        // DE18142
        if (homeCode !== undefined && _.get(claimVM,'mainContact.homeNumber.aspects.required')) {
            _.set(claimVM, 'mainContact.primaryPhoneType.value', 'home')
        }
        else if (workCode !== undefined && _.get(claimVM,'mainContact.workNumber.aspects.required')) {
            _.set(claimVM, 'mainContact.primaryPhoneType.value', 'work')
        }
        else if (cellCode !== undefined && _.get(claimVM,'mainContact.cellNumber.aspects.required')) {
            _.set(claimVM, 'mainContact.primaryPhoneType.value', 'mobile')
        }
       
        updateWizardData(claimVM)
    },[claimVM,updateWizardData]);

    const isValidContactDetails = useCallback(() => {
        const firstName = _.get(claimVM, 'mainContact.firstName');
        const lastName = _.get(claimVM, 'mainContact.lastName');
        const relationToInsured = _.get(claimVM, 'mainContactTypeExt.value');
        let result = true

        if (_.isNull(relationToInsured) || _.isEmpty(relationToInsured)) {
            result = false
        }
        else {
            result = true
        }

        return firstName?.aspects?.valid && firstName?.aspects?.subtreeValid
            && lastName?.aspects?.valid && lastName?.aspects?.subtreeValid && result;

    }, [claimVM]);

    // const changeRequiredNumber = useCallback(
    //     (value, path) => {
    //         _.set(claimVM, path, value);
    //         setHomePhoneValidationMessage([]);
    //         setWorkPhoneMessage([]);
    //         setCellPhoneMessage([]);
    //         updateWizardData(claimVM);
    //     },
    //     [claimVM, updateWizardData]
    // );

    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    }, []);

    const onNext = useCallback(async () => {
        const isHomeNumberValid = claimVM.mainContact?.homeNumber?.aspects?.valid
        const isWorkNumberValid = claimVM.mainContact?.workNumber?.aspects?.valid
        const isCellNumberValid = claimVM.mainContact?.cellNumber?.aspects?.valid
        const isEmailAddressValid = claimVM.mainContact?.emailAddress1?.aspects?.valid

        if ( invalidComponent.length > 0 || !isHomeNumberValid || !isWorkNumberValid || !isCellNumberValid) {
            setHomePhoneValidationMessage(claimVM.mainContact.homeNumber.aspects.validationMessages)
            setWorkPhoneValidationMessage(claimVM.mainContact.workNumber.aspects.validationMessages)
            setCellPhoneValidationMessage(claimVM.mainContact.cellNumber.aspects.validationMessages)
            setShowErrors(true);

            return false;
        }

        if(!isValidContactDetails()) {
            setShowErrors(true);

            return false;
        }

        if (!isEmailAddressValid) {
            setEmailValidationMessage([translator(messages.EmailValidationMessage)])
            setShowErrors(true);
            return false;
        }
 
        setIsAddressEdited(false);
        setShowErrors(false);
        updateWizardData(claimVM);

        return claimVM;
    }, [claimVM, invalidComponent.length, isComponentValid, updateWizardData]);

    const overrides = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showErrors
        },
        fnolContactField: {
            availableValues: availableContacts,
            onValueChange: handleContactChange,
        },
        firstNameField: {
            visible: !(
                _.get(claimVM, 'mainContact.policyRole.value.code') ===
                'insured'
            ),
            required: !(_.get(claimVM, 'mainContact.policyRole.value.code') === 'insured'),
            showRequired: true,
            onValueChange: handleNameChange,
        },
        lastNameField: {
            visible: !(
                _.get(claimVM, 'mainContact.policyRole.value.code') ===
                'insured'
            ),
            required: !(_.get(claimVM, 'mainContact.policyRole.value.code') === 'insured'),
            showRequired: true,
            onValueChange: handleNameChange,
        },
        phoneNumberComponent: {
            visible: !_.isNull(_.get(claimVM, 'mainContact.value')), // DE17267
            accountHolderVM :_.get(claimVM, 'mainContact'), 
            updateSubmissionVM : updateclaimVM, 
            isPerson, showErrors, findInvalidComponent, onValidate,
            setContactUpdated, contactUpdated, 
            homePhoneValidationMessage, setHomePhoneValidationMessage,
            workPhoneValidationMessage, setWorkPhoneValidationMessage,
            cellPhoneValidationMessage, setCellPhoneValidationMessage
        },
        emailAddressComponent: {
            accountHolderVM :_.get(claimVM, 'mainContact'), updateSubmissionVM : updateclaimVM, 
            authHeader, showErrors, findInvalidComponent, onValidate,
            companyType : selectedUWCompany, emailValidationMessages, setEmailAddValidationMsgs : setEmailValidationMessage
        },
        relationshipToInsured: {
            availableValues: claimVM ? getRelationShipTypeValues() : [],
            path: 'mainContactTypeExt'
        },
        mailingAddressComponent: {
            visible: !_.isUndefined(addressVM) && !_.isUndefined(authHeader), // DE17085
            addressVM, updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate,
            companyType : selectedUWCompany,
            xPortal,
            ccConstants,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            ...(isTFPA && { isLossLocation: true }) // DE17071 - To hide country field
        },
        policyIssued: {
            content: isTFPA ? translator(messages.contactPrefWarningMsgTFPA) : translator(messages.contactPrefWarningMsgTWIA)
        },
        mailingAddressBannerText: {
            visible: isTFPA
        },
        callCenterInfo: {
            content: isTFPA ?  translator(messages.tfpaCallCenterText) : translator(messages.twiaCallCenterText)
        },
        contactPreference: {
            content: isTFPA ?  translator(messages.tfpaContactPreference) : translator(messages.twiaContactPreference)
        },
        titleSummaryMsg: {
            visible: !isTFPA
        },
        titleSummaryMsgTFPA: {
            visible: isTFPA
        },

    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(
                metadata.pageContent,
                claimVM,
                id,
                path,
                overrides
            ),
        [claimVM, overrides]
    );

    // if (_.isEmpty(claimVM.value.mainContact)) {
    //     return null;
    // }

    const resolvers = {
        resolveCallbackMap: {
            OnValidateEmail: validateEmail,
            // changeRequiredNumber
        },
        resolveComponentMap: {
            addressComponent: TWIAAddressComponent,
            phoneComponent: TWIAPhoneComponent,
            emailComponent: TWIAEmailComponent,
        },
        resolveClassNameMap: styles,
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={isButtonDisabled || isAddressEdited}
        >
            <Loader loaded={!loader} >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                resolveValue={readValue}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                showErrors={showErrors}
            />
            </Loader>
        </WizardPage>
    );
}

FNOLContactDetailsPage.propTypes = wizardProps;
export default withViewModelService(FNOLContactDetailsPage);
